import React, { useState } from "react";
import { useGlobalContext } from "context/global";
import { useSelector, useDispatch } from "react-redux";
import clsx from "clsx/lite";
import CosmeticRadio from "components/cosmetic-radio";
import { ModalLayout } from "components/subscription-flow";
import addProfileToList from "services/add-profile-to-list";
import { trackRescheduleSubscription } from "services/analytics";
import { TOGGLE_RESCHEDULE_MODAL } from "utils/action-types";
import { toast } from "react-toastify";

const ReschedulingSurvey = () => {
	const { subscriptionSettings = {}, translation } = useGlobalContext();
	const [selectedReason, setSelectedReason] = useState({});
	const { emailAddress: { emailAddress } } = useSelector(state => state.account.profile);
	const { subscriptionId, nextBillingDate } = useSelector(state => state.account.subscription);
	const dispatch = useDispatch();

	const onConfirm = async () => {
		trackRescheduleSubscription(subscriptionId, selectedReason.title, nextBillingDate);
		const response = await addProfileToList(selectedReason.id, emailAddress);
		if (response.success)
			toast.success(translation.subscription.reschedule_survey?.success_message);
		else
			toast.error(translation.subscription.reschedule_survey?.error_message);
		dispatch({ type: TOGGLE_RESCHEDULE_MODAL });
	};

	return (
		<ModalLayout
			confirmationButton={translation.other?.confirm || "Confirm"}
			onConfirm={onConfirm}
			showLoader
			isConfirmDisabled={!selectedReason.id}
			bodyClassName="w-full !h-full !px-0"
		>
			<div className="flex flex-col mt-2 max-h-[95%] overflow-y-auto w-full">
				{subscriptionSettings.reschedulingReasons.map((reason, i) => (
					<button onClick={() => setSelectedReason(reason)} key={i}
						className={clsx("flex justify-between gap-3 p-2", i !== 0 && "border-t")}>
						{reason.title && <h5 className="text-left">{reason.title}</h5>}
						<div className="w-1/12 md:w-auto">
							<CosmeticRadio checked={selectedReason.id === reason.id} />
						</div>
					</button>
				))}
			</div>
		</ModalLayout>
	);
};

export default ReschedulingSurvey;